import { AgeCategoryInTournament, Gender, WeightCategoryInTournament } from './apiClient';

export const formatGenderLabel = (gender?: Gender | null): string => {
  if (gender === Gender.Male) return 'Мальчики';
  if (gender === Gender.Female) return 'Девочки';
  return '';
};

export const isGenderedTournament = (
  weights: WeightCategoryInTournament[] = [],
  ages: AgeCategoryInTournament[] = []
): boolean =>
  weights.some((w) => w.gender != null) || ages.some((a) => a.gender != null);

export const filterWeightByGender = (
  categories: WeightCategoryInTournament[],
  gender?: Gender | null
): WeightCategoryInTournament[] => {
  const list = categories.filter((c) => !c.isDeleted);
  if (!isGenderedTournament(list, [])) return list;
  if (!gender) return list.filter((c) => c.gender == null);
  return list.filter((c) => c.gender == null || c.gender === gender);
};

export const filterAgeByGender = (
  categories: AgeCategoryInTournament[],
  gender?: Gender | null
): AgeCategoryInTournament[] => {
  const list = categories.filter((c) => !c.isDeleted);
  if (!isGenderedTournament([], list)) return list;
  if (!gender) return list.filter((c) => c.gender == null);
  return list.filter((c) => c.gender == null || c.gender === gender);
};

export const categoriesMatchGender = (
  weight?: WeightCategoryInTournament | null,
  age?: AgeCategoryInTournament | null
): boolean => {
  if (!weight?.gender && !age?.gender) return true;
  if (!weight?.gender || !age?.gender) return false;
  return weight.gender === age.gender;
};

export const getTournamentGenders = (
  weights: WeightCategoryInTournament[] = [],
  ages: AgeCategoryInTournament[] = []
): Gender[] => {
  if (!isGenderedTournament(weights, ages)) return [];
  const set = new Set<Gender>();
  weights.forEach((w) => { if (w.gender != null) set.add(w.gender); });
  ages.forEach((a) => { if (a.gender != null) set.add(a.gender); });
  return Array.from(set);
};
